import { ActionButton, DefaultButton, IconButton, Separator, Spinner, Stack, TooltipHost } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';

import { popup } from '../../../addons/Popup';
import archive from './functions/archive';
import downloadPNG from './functions/downloadPNG';
import edit from './functions/edit';
import editPayments from './functions/editPayments';
import editShipment from './functions/editShipment';
import invoice from './functions/invoice';
import print from './functions/print';
import viewHistory from './functions/viewHistory';
import viewInvoice from './functions/viewInvoice';
import viewPDF from './functions/viewPDF';

type Props = {
  formId: string;
  invoiceId?: string;
  focusIconKey?: string;
  migrated?: boolean;
};
type Metas = typeof buttonMetas;

const buttonMetas = [
  { title: "Düzenle", iconName: "Edit", fn: edit, invoiceFilter: false,
    hideMigrated: true
   },
  { title: "PDF Görüntüle", iconName: "PDF", fn: viewPDF },
  {
    title: "Fatura Oluştur",
    iconName: "PageAdd",
    fn: invoice,
    invoiceFilter: false,
  },
  {
    title: "Fatura Görüntüle",
    iconName: "PageLink",
    invoiceFilter: true,
    fn: viewInvoice,
  },
  { title: "Arşivle", iconName: "Archive", fn: archive, invoiceFilter: false,
    hideMigrated: true },
  { title: "Yazdır", iconName: "Print", fn: print,
    hideMigrated: true },
  {
    title: "Ödeme Düzenle",
    iconName: "Money",
    invoiceFilter: false,
    fn: editPayments,
    hideMigrated: true
  },
  {
    title: "Teslimat Düzenle",
    iconName: "DeliveryTruck",
    invoiceFilter: false,
    fn: editShipment,
    hideMigrated: true
  },
  {
    title: "Değişiklikleri Görüntüle",
    iconName: "FullHistory",
    fn: viewHistory,
    hideMigrated: true
  },
  {
    title: "Resim Olarak Kaydet",
    iconName: "FileImage",
    fn: downloadPNG,
    hideMigrated: true
  },
];

const FormAction = ({
  info,
  formId,
  isLarge,
}: { info: Metas[number]; isLarge?: boolean } & Props) => {
  const [isLoading, setLoading] = useBoolean(false);
  const onClick = async () => {
    setLoading.setTrue();

    try {
      await info.fn(formId);
    } catch (e) {
      console.error(e);
      await popup("Form butonu hata verdi görüntülemek için konsola bakın");
    }

    setLoading.setFalse();
  };

  if (isLoading) {
    return <Spinner />;
  }

  const BtnConst = isLarge ? DefaultButton : ActionButton;

  return isLarge ? (
    <BtnConst
      iconProps={{ iconName: info.iconName }}
      text={info.title}
      onClick={onClick}
    />
  ) : (
    <TooltipHost key={info.title} content={info.title}>
      <IconButton iconProps={{ iconName: info.iconName }} onClick={onClick} />
    </TooltipHost>
  );
};

export default (props: Props) => {
  const [isMoreLoading, setIsMoreLoading] = useBoolean(false);
  const rowButtonMetas = buttonMetas.filter((info) =>
    info.invoiceFilter === undefined
      ? true
      : info.invoiceFilter === !!props.invoiceId
  ).filter(info => {
    if (info.hideMigrated) {
      return !props.migrated;
    } else {
      return true;
    }
  });

  if (props.focusIconKey) {
    const info = rowButtonMetas.find((m) => m.iconName === props.focusIconKey);

    if (info) {
      return <FormAction formId={props.formId} info={info} isLarge />;
    }

    return <Separator>İşlem Bulunamadı</Separator>;
  } else {
    const importantButtons = rowButtonMetas.slice(0, 3);
    const otherButtons = rowButtonMetas.slice(3);

    return (
      <Stack horizontal>
        {importantButtons.map((info) => (
          <FormAction formId={props.formId} info={info} />
        ))}
        {isMoreLoading ? (
          <Spinner />
        ) : (
          <IconButton
            iconProps={{ iconName: "More" }}
            // styles={{ menuIcon: { display: "none" } }}
            menuProps={{
              items: otherButtons.map((info) => ({
                key: info.title,
                text: info.title,
                iconProps: { iconName: info.iconName },
                onClick: () => {
                  setIsMoreLoading.setTrue();

                  info
                    .fn(props.formId)
                    .then(setIsMoreLoading.setFalse)
                    .catch(setIsMoreLoading.setFalse);
                },
              })),
            }}
          />
        )}
      </Stack>
    );
  }
};
